export type QuestionType =
  | 'free_form'
  | 'rating'
  | 'multiple_choice'
  | 'yes_no'
  | 'nps'
  | 'date_picker'
  | 'dollar_value'

export interface Question {
  id?: number
  question_type: QuestionType
  prompt: string
  options: string[]
  required: boolean
  position?: number
}

// A rating question stores two endpoint labels when shown as a numeric 1–5 scale (empty = stars).
export const isNumericScale = (options: string[]): boolean => options.length === 2

// Questions that have been persisted to the database — always carry a numeric id.
// Use in response-form code; use Question in builder code where questions may not yet be saved.
export interface PersistedQuestion extends Question {
  id: number
}

// Every question-type child renders one input control and shares this contract.
// The shell (number, label, required, answered state) is owned by QuestionRenderer.
export interface QuestionInputProps {
  question: PersistedQuestion
  value: string
  onChange: (value: string) => void
  // Render a non-interactive preview (used by the builder-track question editor):
  // controls are disabled and onChange won't fire. Defaults to interactive.
  readOnly?: boolean
}
